import { i18n } from '@lib/i18n';
import { createCustomError } from '@avangard/utils/errors';

import type { SchoolRequisitesEntity } from '@modules/schools/entities';
import type { SchoolArgs } from '@modules/types/graphql';

export type UpdateSchoolFormValues = {
    fullName: string;
    requisites: SchoolRequisitesEntity;
};

class UpdateSchoolRequest {
    fullName: SchoolArgs['fullName'];
    requisites: SchoolArgs['requisites'];

    constructor(values: UpdateSchoolFormValues) {
        if (!UpdateSchoolRequest.isRequisitesInputFilled(values.requisites)) {
            throw createCustomError(i18n.t('errors:requisites.not_filled'));
        }

        this.fullName = values.fullName;
        this.requisites = values.requisites;
    }

    static isRequisitesInputFilled(requisites?: SchoolArgs['requisites']): boolean {
        return (
            !!requisites &&
            Object.values(requisites).every(
                value => typeof value === 'string' && value.trim().length > 1,
            )
        );
    }
}

export { UpdateSchoolRequest };
